export const tooltipContents = {
  'files-required': 'Upload your material before the deadline to avoid cancellation',
  'partner_deliverables_ready': 'Download files'
};